import { HttpContext } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { tap } from 'rxjs/operators'
import { DrrHttpClient } from '../../../http/drr-http-client'
import { TIMEOUT_CONFIG } from '../../../shared/services/http-context.tokens'
import { AaaAssistConfirmResponseSchema, validateScenarioResponse } from './aaa-assist.model'
import {
  AAA_ASSIST_TIMEOUT_MS,
  AaaAssistConfirmParams,
  AaaAssistConfirmResponse,
  AaaAssistTriageParams,
  ScenarioResponse,
} from './aaa-assist.types'

@Injectable({
  providedIn: 'root',
})
export class AaaAssistService {
  constructor(private httpClient: DrrHttpClient) {}

  // One call per conversation turn. POST requests are never retried by the retry interceptor.
  triage$(params: AaaAssistTriageParams): Observable<ScenarioResponse> {
    const { clubCode, ...body } = params
    return this.httpClient
      .post<ScenarioResponse>(`/bff/club/${clubCode}/pacesetter-triage`, body, {
        context: this.timeoutContext(),
      })
      .pipe(tap((response) => validateScenarioResponse(response)))
  }

  confirm$(params: AaaAssistConfirmParams): Observable<AaaAssistConfirmResponse> {
    const { clubCode, ...body } = params
    return this.httpClient
      .post<AaaAssistConfirmResponse>(`/bff/club/${clubCode}/pacesetter-triage/confirm`, body, {
        context: this.timeoutContext(),
      })
      .pipe(tap((response) => AaaAssistConfirmResponseSchema.validateSync(response)))
  }

  private timeoutContext = () => new HttpContext().set(TIMEOUT_CONFIG, AAA_ASSIST_TIMEOUT_MS)
}
